import type { Term } from '../types';

/**
 * Picks the single "focus" term for public lesson browsing:
 * — If any active term is currently in session (now within [startDate, endDate]), returns that term.
 * — Otherwise returns the earliest upcoming active term (startDate > now, still not ended).
 * — Returns null if there is no applicable term.
 */
export function getFocusTerm(terms: Term[], now: Date): Term | null {
  const active = terms.filter((t) => t.isActive);
  if (active.length === 0) return null;

  const inSession = active.filter((t) => {
    const start = new Date(t.startDate);
    const end = new Date(t.endDate);
    return now >= start && now <= end;
  });

  if (inSession.length > 0) {
    inSession.sort(
      (a, b) => new Date(a.startDate).getTime() - new Date(b.startDate).getTime()
    );
    return inSession[0] ?? null;
  }

  const upcoming = active.filter((t) => {
    const start = new Date(t.startDate);
    const end = new Date(t.endDate);
    return start > now && end >= now;
  });

  if (upcoming.length === 0) return null;

  upcoming.sort(
    (a, b) => new Date(a.startDate).getTime() - new Date(b.startDate).getTime()
  );
  return upcoming[0] ?? null;
}
